import React from "react";
import "./css/contact.css"; 

function Contact() {
  return (
    <div className="up" data-aos="fade-up">
    <div className="contact-container" >
      <h2>تواصل معنا</h2>
      <form className="contact-form">
        <div className="form-group">
          <label htmlFor="name">الاسم</label>
          <input type="text" id="name" required placeholder="أدخل اسمك" />
        </div>
        <div className="form-group">
          <label htmlFor="email">البريد الإلكتروني</label>
          <input type="email" id="email" required placeholder="أدخل بريدك الإلكتروني" />
        </div>
        <div className="form-group">
          <label htmlFor="message">الرسالة</label>
          <textarea id="message" rows="4" required placeholder="أدخل رسالتك"></textarea>
        </div>
        <button type="submit" className="submit-button">إرسال</button>
      </form>
    </div>
    </div>
  );
}

export default Contact;
